// extracted by mini-css-extract-plugin
export default {"link":"AboutModal-styles-module--link--ufS4r"};